import {Component, EventEmitter, forwardRef, Injector, Input, Output, Type} from "@angular/core";
import {ColumnComponent} from "../../grid/column.component";
import {AbstractColumnComponent} from "../../grid/abstract-column.component";
import {EditMode} from "../edit-page/edit-mode";
import {EntityData} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-edit-link-column",
    styleUrls: ["./edit-link-column.component.scss"],
    templateUrl: "./edit-link-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => EditLinkColumnComponent), multi: true}
    ]
})
export class EditLinkColumnComponent extends AbstractColumnComponent {
    @Input() componentPath: string;
    @Input() editComponent: Type<any>;
    @Input() editPath: string;
    @Input() editParams: any;
    @Input() parentEntity: any;
    @Input() editMode: EditMode;
    @Input() showDiscontinued: boolean;

    @Output() onSave: EventEmitter<EntityData<any>> = new EventEmitter<EntityData<any>>();

    constructor(injector: Injector) {
        super(injector);
        this.linkable = true;
    }

    dataItemSaved(dataItem: EntityData<any>, saved: EntityData<any>): void {
        EntityData.getField(dataItem, this.componentPath).assign(saved);
        this.onSave.emit(saved);
    }
}
